/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Home_DescriptionInputs */

const en_seo_home_description = /** @type {(inputs: Seo_Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the best AI tool for every task — writing, video, code, design. Independently scored, pricing verified weekly, alternatives compared. Updated regularly.`)
};

const zh_seo_home_description = /** @type {(inputs: Seo_Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写作、视频、代码、设计——每个任务最好的 AI 工具：独立六维评分、定价每周核实、替代逐项对比，持续更新。`)
};

/**
* | output |
* | --- |
* | "Find the best AI tool for every task — writing, video, code, design. Independently scored, pricing verified weekly, alternatives compared. Updated regularly." |
*
* @param {Seo_Home_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_home_description = /** @type {((inputs?: Seo_Home_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Home_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_home_description(inputs)
	return zh_seo_home_description(inputs)
});
export { seo_home_description as "seo.home.description" }